function makeXmlParser(mimeType = 'text/xml') {
    // SSR
    if (__SERVER__) {
        return undefined;
    }
    if (window.DOMParser !== undefined) {
        return xmlStr =>
            new window.DOMParser().parseFromString(xmlStr, mimeType);
    } else if (
        window.ActiveXObject !== undefined &&
        new window.ActiveXObject('Microsoft.XMLDOM')
    ) {
        return xmlStr => {
            const xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
            xmlDoc.async = 'false';
            xmlDoc.loadXML(xmlStr);
            return xmlDoc;
        };
    } else {
        throw new Error('No XML parser found');
    }
}

/**
 * Разбирает адресную строку на составные части.
 * @param {string} value
 */
function uri(value) {
    const parser = document.createElement('a');
    parser.href = value;
    /*
        parser.protocol; // => "http:"
        parser.hostname; // => "example.com"
        parser.port;     // => "3000"
        parser.pathname; // => "/pathname/"
        parser.search;   // => "?search=test"
        parser.hash;     // => "#hash"
        parser.host;     // => "example.com:3000"
        */
    return parser;
}

/**
 * Преобразует строку query-параметров в объект { параметр: значение }.
 * @param {string} value
 * @returns {Object}
 */
function query(value) {
    return /^\??(.*)/
        .exec(value || '')[1]
        .split('&')
        .map(
            function m(n) {
                // eslint-disable-next-line
                return (n = n.split('=')), (this[n[0]] = n[1]), this;
            }.bind({})
        )[0];
}

/**
 * Парсит непустые строки при помощи JSON.parse.
 */
function textToJson(jsonStr) {
    return jsonStr ? JSON.parse(jsonStr) : null;
}

const parse = {
    xml: makeXmlParser(),
    html: makeXmlParser('text/html'),
    json: textToJson,
    uri,
    query
};

export default parse;
